import { ICombo, IItem, IPicker, IPickerOption } from '@rbi-ctg/menu';

//resolves picker selections to a single option
export function computeSelectedOption<
  T extends ICombo | IItem | IPicker | { _type: string; options?: (IPickerOption | null)[] | null }
>(pickerSelections: Record<string, string> | null | undefined, item: T) {
  if (item._type === 'combo' || item._type === 'item') {
    return item;
  }

  const pickerItem = item as IPicker | { _type: string; options?: (IPickerOption | null)[] | null };
  const options = pickerItem.options;
  const pickerValues = pickerSelections ? Object.values(pickerSelections) : [];

  if (!pickerSelections || pickerValues.length < 1) {
    const firstOption = Array.isArray(options) ? options[0] : undefined;
    return firstOption?.option || false;
  }

  const resolution = Array.isArray(options)
    ? options.find(itemOpt => {
        return itemOpt?.pickerItemMappings?.every(mapping => {
          const aspectId = mapping?.pickerAspect?._id;
          if (!aspectId) {
            return false;
          }
          return pickerSelections[aspectId] === mapping?.pickerAspectValueIdentifier;
        });
      })
    : undefined;

  return resolution?.option || false;
}
